import getWithToken from '../base/get-with-token'

const getReport = id => getWithToken(`/report/${id}`)()

export default getReport